const LeftGraph = ({ okPercent, healthyCount, errorCount, total }) => {
  return (
    <>
      <section className="card status-card">
        <h2 className="card-title">Application Monitoring Dashboard</h2>

        <div className="status-main">
          <div className="donut-wrapper">
            <div
              className="donut-chart"
              style={{
                background: `conic-gradient(
                      #16a34a 0 ${okPercent}%,
                      #ef4444 ${okPercent}% 100%
                    )`,
              }}
            >
              <div className="donut-center">
                <div className="donut-center-number">{healthyCount}</div>
                {/* <div className="donut-center-label">Healthy</div> */}
              </div>
            </div>
          </div>

          <div className="status-legend">
            <div className="legend-item">
              <div className="legend_wrapper">
                  <span className="legend-color ok"></span>
                  <span className="legend-label">Operational APIs</span>
              </div>
              <div className="legend-item">
              <div className="legend_wrapper">
                
                  <span className="legend-color error"></span>
                  <span className="legend-label">Failed</span>
                  </div>
              </div>
            </div>

            <div className="stat-cards">
              <div className="stat-card ok">
                <div className="stat-number">{healthyCount}</div>
                <div className="stat-label">Operational APIs</div>
              </div>
              <div className="stat-card error">
                <div className="stat-number">{errorCount}</div>
                <div className="stat-label">Failed APIs</div>
              </div>
             
            </div>
            <div className="stat-cards">
             <div className="stat-card neutral">
                <div className="stat-number">{total}</div>
                <div className="stat-label">Total APIs Monitored</div>
              </div>
              </div>
              {/* Status Widget */}
<div
  className={`issues-widget ${
    errorCount > 0 ? "issues-widget-error" : "issues-widget-success"
  }`}
>
  <div className="issues-widget-icon">
    {errorCount > 0 ? "⚠️" : "✅"}
  </div>

  <div className="issues-widget-content">
    <div className="issues-widget-title">
      {errorCount > 0 ? "Issues Detected" : "No Known Issues"}
    </div>

    <div className="issues-widget-text">
      {errorCount > 0
        ? `${errorCount} API${errorCount > 1 ? "s are" : " is"} currently failing`
        : "All monitored APIs are operating normally"}
    </div>
  </div>
</div>
          </div>
        </div>
      </section>
    </>
  )
}

export default LeftGraph
